import { ArrowUpRight } from "lucide-react";
import { NEWS } from "../../data/content";
import { SectionHeading } from "../common";
import { Reveal } from "../Reveal";

export const LatestNews = () => (
    <section className="py-24 md:py-32 border-b border-thg-border" data-testid="latest-news-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <SectionHeading
                index="07"
                overline="Latest from THG"
                title="Current work, on the record."
                linkTo="/news"
                linkLabel="All news & insights"
                linkTestId="news-view-all"
            />
            <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {NEWS.slice(0, 4).map((item, i) => (
                    <Reveal
                        key={item.title}
                        delay={i * 0.08}
                        className="border-t-2 border-thg-border pt-6 hover:border-thg-red transition-colors duration-300"
                        data-testid={`news-item-${i}`}
                    >
                        <p className="text-[10px] tracking-[0.2em] uppercase font-bold text-thg-tertiary">
                            {item.type}
                            {item.date && <span className="text-thg-tertiary/70"> &middot; {item.date}</span>}
                        </p>
                        <h3 className="mt-3 font-display text-lg md:text-xl font-medium text-white leading-snug">
                            {item.title}
                        </h3>
                        <p className="mt-3 text-sm leading-relaxed text-thg-secondary">{item.text}</p>
                        {item.href && (
                            <a
                                href={item.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid={`news-link-${i}`}
                                className="mt-4 inline-flex items-center gap-1.5 text-xs tracking-[0.15em] uppercase text-thg-secondary hover:text-white transition-colors duration-300"
                            >
                                Read <ArrowUpRight size={13} />
                            </a>
                        )}
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.2} className="mt-12">
                <a
                    href="https://warroomlabs.substack.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="home-research-cta"
                    className="inline-flex items-center gap-2 text-sm text-thg-secondary hover:text-white transition-colors duration-300 group"
                >
                    Read WarRoom Labs Research
                    <ArrowUpRight size={16} className="text-thg-red transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
            </Reveal>
        </div>
    </section>
);
